export class Status {
    id: number
    title: string
}


/** WEBPACK FOOTER **
 ** ./src/app/service/status/status.ts
 **/